import { ParsedReportParams } from '@ais-ui/websockets';
import { ReportType } from '../../../reportsTypes';
import { useCallback } from 'react';
import { findFilterTypeFromReport } from '../../utils/findFilterTypeFromReport';

interface Ship {
  name: string;
  mmsi: string;
  callsign: string;
  imo: string;
}

interface ShipFormValue {
  name: string;
  mmsi: string;
  callSign: string;
  imo: string;
  type: string;
}

export function useInitializeFilter(
  report: ParsedReportParams | undefined,
  reportType: ReportType,
) {
  return useCallback(() => {
    const initialFilterType = findFilterTypeFromReport(report, reportType);
    const filterObject: Record<
      string,
      string | string[] | boolean | ShipFormValue[] | undefined
    > = {};

    // If no report exists (creating new), return empty filter object
    if (!report || !initialFilterType || !reportType.filter) {
      return filterObject;
    }

    const filterItemsArray = reportType.filter[initialFilterType];
    if (!filterItemsArray) {
      return filterObject;
    }

    for (const filterItem of filterItemsArray) {
      if (initialFilterType === 'normal') {
        const filter = report?.params?.['FID'];
        filterObject[filterItem.name] = filter || undefined;
      } else if (initialFilterType === 'shiplist') {
        const shiplist = report?.params?.['SHPL'];
        filterObject[filterItem.name] = shiplist || [];
      } else if (initialFilterType === 'ship') {
        const ships = report?.params?.['TL'];
        if (ships && Array.isArray(ships)) {
          const ship = ships.map((ship: Ship) => ({
            name: ship.name,
            mmsi: ship.mmsi,
            callSign: ship.callsign,
            imo: ship.imo,
            type: '',
          }));
          filterObject[filterItem.name] = ship;
        } else {
          filterObject[filterItem.name] = [];
        }
      } else if (initialFilterType === 'combined') {
        if (filterItem.name === 'shiplist') {
          const shiplist = report?.params?.['SHPL'];
          filterObject[filterItem.name] = shiplist || [];
        } else {
          const filter = report?.params?.['FID'];
          filterObject[filterItem.name] = filter || undefined;
        }
      }
    }

    return filterObject;
  }, [report, reportType]);
}
